<template>
  <div class="Login" />
</template>
<script>
export default {
  name: 'Login',
  components: {},
  data() {
    return {}
  },
  watch: {},
  created() {
    var usercode = localStorage.getItem('userCode')
    // var usercode = '2018068'// localStorage.getItem('userCode')
    if (usercode === null || typeof (usercode) === 'undefined') { window.location.href = 'login.html' }
    this.$store.dispatch('user/login', usercode).then(() => {
      console.log('Login Succeseed ' + usercode)
      this.$router.push({ path: this.redirect || '/', query: this.otherQuery })
      console.log('this.redirect', this.redirect)
      this.loading = false
    }).catch(() => {
      console.log('Login Failed')
      this.loading = false
    })
  },
  methods: {}
}
</script>
